import axios from 'axios';
import base_url from '../baseUrls';
import ApiUtils from './apiUtils';

/**
 * Company ids that the signed-in user's companies span, including every
 * descendant in the hierarchy.
 *
 * The analytics pages report per company, and an Enterprise account holds no
 * jobs of its own -- its Primary and Sub-Account members carry all of them. So
 * querying with only the ids stored on the user record returns nothing at all
 * for an Enterprise admin. The backend walks the tree in both of the directions
 * it is recorded in, since the parent/child link is denormalized on both sides
 * and either one may be the populated one.
 *
 * Falls back to `rootIds` when the lookup fails, so a hierarchy outage degrades
 * to the previous single-company behavior rather than an empty report.
 */
const fetchHierarchyCompanyIds = async (rootIds) => {
  try {
    const authHeader = await ApiUtils.getAccessToken();

    const response = await axios.post(
      `${base_url.api}companies/hierarchy-ids`,
      {},
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: authHeader,
        },
      }
    );

    const ids = response?.data?.data?.companyIds;

    return Array.isArray(ids) && ids.length > 0 ? ids : rootIds;
  } catch (err) {
    console.error('Could not resolve company hierarchy, using assigned companies', err);
    return rootIds;
  }
};

export default fetchHierarchyCompanyIds;
